import { Col, Form, InputGroup, Row } from 'react-bootstrap';

interface FallbackVariantSectionProps {
  defaultId: string;
  defaultUrl: string;
  readOnly: boolean;
  onDefaultIdChange: (value: string) => void;
  onDefaultUrlChange: (value: string) => void;
}

export const FallbackVariantSection = ({
  defaultId,
  defaultUrl,
  readOnly,
  onDefaultIdChange,
  onDefaultUrlChange
}: FallbackVariantSectionProps) => (
  <Row>
    <Form.Group as={Col} className='form-group'>
      <Form.Label>Fallback Variant</Form.Label>
      <div className='helper-text'>
        <p>
          Please enter a full fallback variant URL, starting with HTTPS. User would be shown this
          variant if no others variants met split conditions or there was an error evaluating
          traffic split conditions.
          <br />
          <br />
          Example: https://www.insiderenvy.com/3-reasons-get-starz-v3-title1-syft
          <br />
          <br />
          Please note that all fallback variant ID values will have &quot;f-&quot; automatically
          prepended in front of the value if it is not present. This would help with reporting and
          monitoring of traffic splits.
        </p>
      </div>
      <div className='fallback-variant-builder'>
        <InputGroup>
          <Form.Control
            disabled={readOnly}
            className='fallback-variant-id'
            type='text'
            placeholder='Fallback Variant ID'
            value={defaultId || ''}
            onChange={e => onDefaultIdChange(e.target.value)}
          />
          <Form.Control
            disabled={readOnly}
            className='fallback-variant-url'
            type='text'
            placeholder='Fallback Variant URL'
            value={defaultUrl || ''}
            onChange={e => onDefaultUrlChange(e.target.value)}
          />
        </InputGroup>
      </div>
    </Form.Group>
  </Row>
);
